import { each } from 'lodash/fp';
import { keyById } from '@mews/fp';
import { createScopedReducer } from '@mews-commander/utils';
import {
    SEARCH_RESULT_SELECTED,
    SELECTED_SEARCH_RESULT_CLEARED,
    SEARCH_RESULTS_CLEARED,
    SEARCH_STARTED,
    SEARCH_SUCCEEDED,
    SEARCH_FAILED,
    SEARCH_MORE_STARTED,
    SEARCH_MORE_SUCCEEDED,
    SEARCH_MORE_FAILED,
    SEARCH_RESETED,
} from './actions/actionTypes';

export const INITIAL_STATE = {
    results: {},
    selected: null,
};

export default createScopedReducer(INITIAL_STATE, {
    [SEARCH_RESETED]: () => INITIAL_STATE,

    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [SEARCH_RESULT_SELECTED]: (state, selectedResult) => ({
        ...state,
        selected: selectedResult,
    }),

    [SELECTED_SEARCH_RESULT_CLEARED]: (state: $TSFixMe) => ({
        ...state,
        selected: null,
    }),

    [SEARCH_RESULTS_CLEARED]: (state: $TSFixMe) => ({
        ...state,
        results: {},
    }),

    [SEARCH_STARTED]: (state: $TSFixMe) => ({
        ...state,
        results: {},
        selected: null,
        isFetching: true,
        hasFailed: false,
    }),

    [SEARCH_SUCCEEDED]: (state: $TSFixMe, results: $TSFixMe) => {
        const newState = {
            ...state,
            isFetching: false,
            hasFailed: false,
            results: { ...state.results },
        };

        each(({ searchType, result, hasMore }) => {
            const keyedResult = keyById(result);
            newState.results[searchType] = {
                items: keyedResult,
                hasMore,
            };
        }, results);

        return newState;
    },

    [SEARCH_FAILED]: (state: $TSFixMe) => ({
        ...state,
        isFetching: false,
        hasFailed: true,
    }),

    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [SEARCH_MORE_STARTED]: (state, { searchType }: $TSFixMe) => ({
        ...state,

        results: {
            ...state.results,
            [searchType]: {
                ...state.results[searchType],
                isFetching: true,
            },
        },
    }),

    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [SEARCH_MORE_SUCCEEDED]: (state, { searchType, hasMore, result }: $TSFixMe) => ({
        ...state,

        results: {
            ...state.results,
            [searchType]: {
                ...state.results[searchType],
                hasMore,
                isFetching: false,
                items: { ...state.results[searchType].items, ...keyById(result) },
            },
        },
    }),

    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [SEARCH_MORE_FAILED]: (state, { searchType }: $TSFixMe) => ({
        ...state,

        results: {
            ...state.results,
            [searchType]: {
                ...state.results[searchType],
                isFetching: false,
            },
        },
    }),
});
